export default __webpack_public_path__ + "static/media/video_fr.e225eae6.mp4";